import { Batch } from '@shared/scenes/cards/entityBulkActions/BatchCreateContext/BatchContext';
import { useIsDesktop } from '@shared/util/hooks';
import { YearOptionsDesktop } from './YearOptionsDesktop';
import { YearOptionsMobile } from './YearOptionsMobile';

export function YearOptions(props: Pick<Batch, 'rruleOptions' | 'setRruleOptions'>) {
  const isDesktop = useIsDesktop();

  if (isDesktop) {
    return <YearOptionsDesktop {...props} />;
  } else {
    return <YearOptionsMobile {...props} />;
  }
}
